import i18n from '@/i18n.js';
import Cookie from 'js-cookie';
import { SET_DOCUMENT_TITLE } from '@/utils/document';

const state = {
    locale: i18n.locale,
    apiLocale: i18n.locale
};

const mutations = {
    SET_LANGUAGE(state, code) {
        state.locale = code
    },
    SET_API_LOCALE(state, code) {
        state.apiLocale = code
    },
};

const getters = {
    IS_RTL(state) {
        return state.locale == 'ku' || state.locale == 'ar';
    },
    CURRENT_LOCALE(state) {
        return state.locale;
    },
    API_LOCALE(state) {
        return state.apiLocale;
    }
};

const actions = {
    SET_LANGUAGE({ commit }, code) {
        commit('SET_LANGUAGE', code)
        i18n.locale = code;
        Cookie.set('lang', code);
        SET_DOCUMENT_TITLE(i18n.t('pages.home.title'))
    },
    SET_API_LOCALE({ commit }, api) {
        Cookie.set('api', api);
        commit('SET_API_LOCALE', api)
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
